module.exports = __webpack_public_path__ + "static/media/profile-photo.f17c17ac.png";